import styles from "./analytics-table.module.css"

export default function WorstSellingProducts({ products }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Worst Selling Products</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Product</th>
              <th>Quantity</th>
              <th>Failure Rate</th>
              <th>Days Inactive</th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product, index) => (
              <tr key={index}>
                <td>{product._id.name}</td>
                <td>{product.totalQuantity}</td>
                <td className={styles.warning}>{product.failureRate}%</td>
                <td>{product.daysSinceLastOrder}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
